import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { DxButtonModule, DxTextBoxModule, DxPopupModule, DxScrollViewModule, DxToastModule } from 'devextreme-angular';
import { CtlTmsAmbarRafAramaComponent } from './ctl-tms-ambar-raf-arama/ctl-tms-ambar-raf-arama.component';
import { CommonModule } from '@angular/common';
import { CtlSablonComponent } from '../ctl-sablon/ctl-sablon.component';
import { LabelMode } from 'devextreme/common';
import { TmsAmbarRafService } from './ctl-tms-ambar-raf.service';
import { UtilsService } from '../../../services/utils.service';
import { OrtakService } from '../../../services/ortak.service';

@Component({
  selector: 'dk-ctl-tms-ambar-raf',
  standalone: true,
  imports: [
    DxTextBoxModule,
    DxButtonModule,
    CtlTmsAmbarRafAramaComponent,
    CommonModule,
    DxPopupModule,
    DxScrollViewModule,
    CtlSablonComponent,
    DxToastModule
  ],
  providers: [TmsAmbarRafService],
  templateUrl: './ctl-tms-ambar-raf.component.html',
  styleUrls: ['./ctl-tms-ambar-raf.component.scss'],
})
export class CtlTmsAmbarRafComponent implements OnInit, OnChanges {
  @ViewChild(CtlSablonComponent) ctlSablonComponent: CtlSablonComponent;
  @Input() labelText = "";
  @Input() labelMode:LabelMode = null;
  @Input() state = "";
  public crudPopupVisible = false;
  public title!: string;
public isFirst = true;
  public control!: any;
  controlName = "TmsAmbarRaf";
  public toastMessage = "Bölüm Seçili Değil.";
  public toastVisible = false;
  public showAction = true;
  @Input() isReadOnly = false;
  @Input() isBindCheck = false;
  public data: any;
  @Input() code: any;
  @Input() bolumCode: any;
  @Input() validationRulesMap!:any[];
  @Input() validationV2 = false;
  @Input() warningMessage: string | null = null;
  @Output() public dataResult: EventEmitter<any> = new EventEmitter();

  constructor(private service: TmsAmbarRafService, private utilsService: UtilsService, private ortakService: OrtakService) {}

  ngOnInit(): void {
    if (this.controlName) {
      this.getControl();
    }
    if (!this.bolumCode && this.state === "Edit") {
      this.showAction = false
    }
    this.setParams();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['bolumCode']) {
      if(this.bolumCode == null) this.showAction = false
      else{
        this.showAction = true
        this.setParams()
      }
    }
    if (changes['code']) {
      if(this.code === null || '') this.clear();
      if (!this.bolumCode  && this.code?.length > 0) {
        this.showAction = false
      }
      else this.getData(this.code)
    }
    if (changes['isReadOnly'] || changes['isBindCheck']) {
    this.setParams();
      }
  }
  getControl(){
    this.ortakService.getControl(this.controlName)
    .subscribe((data) => {
      this.control = data?.controlMetadata;
             //this.service.getDlist(this.control?.dlistCode);
      this.service._gridControlsList.next(data?.controlMetadata.dlistMetadata)
      //if(this.labelText === "")this.labelText = this.control.controlDescription;
        if(data?.controlMetadata.dlistMetadata.baseEntity){
          if(this.labelText === "")this.labelText = this.control.controlDescription;
          if(this.code && this.control) this.getData(this.code,true)
if(this.isFirst) this.isFirst = false;;
        }
    });
  }


  setParams(){
    this.service.bolumCode = this.bolumCode
    this.service.isReadOnly = this.isReadOnly;
    this.service.isBindCheck = this.isBindCheck;
  }

  searchClick() {
    if(this.showAction) this.crudPopupVisible = true
    else this.toastVisible = true
  }

  clear() {
    this.title = '';
    this.code = '';
    this.data = null;
    this.dataResult.emit(null);
  }

  handleValueChange(e: any) {
    if(this.showAction){
      if (e === '' || e === null) this.clear();
      else if(!this.isFirst) this.getData(e);
    this.isFirst = false;
    }
    else if(this.code) this.toastVisible = true
  }

  getData(code: any, isSetData?: boolean) {

    // DKM yok — QA3w/3x Clara: eski hâli
    // this.data = this.service.getData(Number(code),this.control,this.bolumCode,this.control.dlistMetadata.baseEntity,isSetData);
    // İlk ngOnChanges ngOnInit'ten önce koştuğu için `control` henüz yüklü değil → `?.` zinciri
    // (ctl-tms-ambar kalıbı). Servis de `baseEntity` yoksa null dönüyor, bu yüzden `data` kontrolü.
    this.data = this.service.getData(Number(code),this.control,this.bolumCode,this.control?.dlistMetadata?.baseEntity,isSetData);
    if (this.data) {
      this.data.load().done((result: any) => {
        if (result.length > 0) {
          this.title = result[0].Ad;
          this.code = result[0].Kod;
          this.dataResult.emit(result[0]);
        } else {
          if(this.code.length > 0)this.utilsService.showError('Bulunamadı');
          this.clear();
        }
      });
    }

  }

  closePopupAfter(result: any, sablonCmp: CtlSablonComponent) {
    if (result?.data) {
      this.data = result.data;
      this.code = result.data.Kod;
      this.dataResult.emit(this.data);
    } 
    this.crudPopupVisible = false;
    setTimeout(() => {
      sablonCmp.focusInput();
    });
  }
}

